<template>
  <div
    class="login-page items-center justify-center"
    :class="isVKNOWS ? 'login-page-vknows' : 'login-page-nerdof'"
  >
    <!-- <div class="mx-auto"> -->
    <div class="login-container">
      <v-card v-if="window == 0" class="item-card pt-12 pb-12" elevation="0">
        <warnningComponent
          v-bind:textInfo.sync="textWarning"
          v-bind:typestatus.sync="typeWarning"
          v-bind:alert.sync="showWarnnig"
        ></warnningComponent>
        <div class="logo">
          <v-img v-if="isVKNOWS" src="@/assets/vknows.png"></v-img>
          <v-img v-if="isNerdOf" src="@/assets/logomark.png"></v-img>
        </div>
        <div class="titile mt-2 mb-10">
          <v-card-title
            primary-title
            class="justify-center pa-0 mb-3 tula-title"
            >Sign in</v-card-title
          >
          <p
            class="
              subtitle
              text-center
              origanization-detail
              font-weight-regular
              grey--text
              text--darken-1
            "
          >
            Use your Organization Account
          </p>
        </div>

        <v-form
          ref="form"
          lazy-validation
          v-model="valid"
          v-on:submit.prevent="submit"
          class="px-5"
        >
          <v-text-field
            outlined
            v-model="model.username"
            type="email"
            name="email"
            :rules="requireRule"
            placeholder="E-mail / Username"
            required
            clearable
            dense
            :autofocus="false"
            class="md-w-100 xs-full-width m-auto user-icon txt-field"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mr-2">mdi-account-supervisor</v-icon>
            </template>
          </v-text-field>

          <div class="text-center mt-2 mb-8 btn-section">
            <v-btn
              :disabled="!valid"
              :color="isVKNOWS ? '#4BD0A0' : '#072F72'"
              class="md-w-100 xs-full-width white--text next-btn"
              large
              elevation="0"
              @click="submit"
              >NEXT</v-btn
            >
          </div>
          <div class="text-center py-12">
            <a
              href="https://nerdof.com/termOfUse"
              class="text--primary grey--text text--darken-1 txt-hyperLink"
              >Terms & Condition</a
            >
          </div>
        </v-form>
      </v-card>

      <v-card v-if="window == 1" class="item-card pt-12 pb-12" elevation="0">
        <div class="logoSelectCompany my-0">
          <v-img v-if="isVKNOWS" src="@/assets/vknows.png"></v-img>
          <v-img v-if="isNerdOf" src="@/assets/logomark.png"></v-img>
        </div>
        <div class="titile my-2 mb-10">
          <v-card-title
            primary-title
            class="titile justify-center pa-0 font-weight-bold"
            >Select Company</v-card-title
          >
          <p class="text-center">Please select your company.</p>
        </div>
        <v-card height="400px" class="scroll border-card-select">
          <v-list-item
            v-for="(company, index) in companyData"
            @click="identifyCompany(index)"
            :key="company._id"
          >
            <v-list-item-avatar>
              <v-img :src="company.companies[0].logo" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                :style="{ color: company.companies[0].themeColor }"
                >{{ company.companies[0].title }}</v-list-item-title
              >
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-card>

      <v-card v-if="window == 2" class="item-card pt-12 pb-12" elevation="0">
        <warnningComponent
          v-bind:textInfo.sync="textWarning"
          v-bind:typestatus.sync="typeWarning"
          v-bind:alert.sync="showWarnnig"
        ></warnningComponent>
        <div class="logo">
          <v-img v-if="!logoCompany" src="@/assets/logomark.png"></v-img>
          <v-img v-if="logoCompany" :src="logoCompany"></v-img>
        </div>
        <div class="titile mt-2 mb-10">
          <v-card-title
            primary-title
            v-if="!titleCompany"
            class="justify-center pa-0 mb-3 tula-title"
            >Hello</v-card-title
          >
          <v-card-title
            primary-title
            v-if="titleCompany"
            class="justify-center pa-0 mb-3 tula-title"
            >{{ titleCompany }}</v-card-title
          >
          <!-- <div style="margin: auto;" class="subtitle-1" v-text="companyData.email"></div> -->
          <p class="text-center title origanization-detail account-color">
            {{ companyData.email }}
          </p>
        </div>
        <v-form
          ref="form2"
          lazy-validation
          v-model="valid2"
          v-on:submit.prevent="submitPwd"
          class="px-5"
        >
          <v-text-field
            outlined
            v-model="model.password"
            type="password"
            :rules="passwordRule"
            placeholder="Password"
            prepend-inner-icon="far fa-user-friends"
            clearable
            dense
            :autofocus="false"
            name="password"
            class="md-w-100 xs-full-width m-auto user-icon"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mr-2">far fa-key</v-icon>
            </template>
          </v-text-field>
          <div class="text-center mt-2 mb-8">
            <v-btn
              :disabled="!valid2"
              :color="isVKNOWS ? '#4BD0A0' : '#072F72'"
              class="md-w-100 xs-full-width white--text next-btn"
              large
              @click="submitPwd"
              >SIGN IN</v-btn
            >
            <div style="float: right; padding-right: 20px">
              <p class="mt-2 size font-weight-light">
                <a @click="switchToForgetPassword">
                  <span
                    style="color: #1a3f7d !important"
                    class="txt-hyperLink caption font-weight-bold"
                    >Forget Password</span
                  >
                </a>
              </p>
            </div>
          </div>

          <div class="text-center py-12">
            <a
              href="https://nerdof.com/termOfUse"
              class="text--primary grey--text text--darken-1 txt-hyperLink"
              >Terms & Condition</a
            >
          </div>
        </v-form>
      </v-card>

      <v-card v-if="window == 3" class="item-card pt-12 pb-12" elevation="0">
        <warnningComponent
          v-bind:textInfo.sync="textWarning"
          v-bind:typestatus.sync="typeWarning"
          v-bind:alert.sync="showWarnnig"
        ></warnningComponent>
        <div class="logo">
          <v-img v-if="!logoCompany" src="@/assets/logomark.png"></v-img>
          <v-img v-if="logoCompany" :src="logoCompany"></v-img>
        </div>
        <div class="titile px-6 mt-5 mb-10">
          <v-card-title
            primary-title
            class="justify-center pa-0 mb-3 tula-title"
            >Forgot your password?</v-card-title
          >
          <p
            class="
              subtitle
              text-center
              origanization-detail
              font-weight-regular
              grey--text
              text--darken-1
            "
          >
            {{ "Do you want to change your password now?" }} <br />
            {{ "When you click RESET, We'll send your new password to " }}
            <span style="color: #1a3f7d !important" class="font-weight-black">{{
              model.username
            }}</span>
          </p>
        </div>
        <div class="text-center mt-2 mb-8">
          <v-btn
            width="50%"
            :disabled="!model.username"
            :color="isVKNOWS ? '#4BD0A0' : '#072F72'"
            class="md-w-100 xs-full-width white--text next-btn"
            large
            @click="repassword"
            >RESET</v-btn
          >
        </div>

        <div class="text-center py-12">
          <a
            href="https://nerdof.com/termOfUse"
            class="text--primary grey--text text--darken-1 txt-hyperLink"
            >Terms & Condition</a
          >
        </div>
      </v-card>

      <v-card v-if="window == 4" class="item-card pt-12 pb-12" elevation="0">
        <warnningComponent
          v-bind:textInfo.sync="textWarning"
          v-bind:typestatus.sync="typeWarning"
          v-bind:alert.sync="showWarnnig"
        ></warnningComponent>
        <div class="titile px-6 mt-5 mb-10">
          <v-card-title
            primary-title
            style="color: #1a3f7d !important"
            class="font-weight-black justify-center pa-0 mb-3 tula-title"
            >Check your email</v-card-title
          >
          <p
            class="
              subtitle
              text-center
              origanization-detail
              font-weight-regular
              grey--text
              text--darken-1
            "
          >
            {{ "We have just sent an email with you new password." }}
          </p>
        </div>
        <div class="text-center px-6 mt-2 mb-8">
          <v-btn
            width="50%"
            :color="isVKNOWS ? '#4BD0A0' : '#072F72'"
            class="md-w-100 xs-full-width white--text next-btn"
            large
            @click="backToSignIn"
            >Sign in</v-btn
          >
        </div>

        <div class="text-center py-12">
          <p
            class="
              subtitle
              text-center
              origanization-detail
              font-weight-light
              grey--text
              text--lighten-1
            "
          >
            {{ "For any further questions or problems, please emailus at" }}
            <span class="font-weight-black">support@deknerd.com</span>
          </p>
          <a
            href="https://nerdof.com/termOfUse"
            class="text--primary grey--text text--darken-1 txt-hyperLink"
            >Terms & Condition</a
          >
        </div>
      </v-card>

      <v-card
        class="item-card pt-12 pb-12 hidden-xs login-information-nerdof"
        elevation="0"
        v-if="isNerdOf"
      >
        <div class="information">
          <p class="display-1 title">Advance E-Learning Platform</p>
          <p class="title detail white--text">
            Enhancing teaching and learning experience with breakthrough
            features.
          </p>
        </div>
      </v-card>
      <v-card
        class="item-card pt-12 pb-12 hidden-xs login-information-vknows"
        elevation="0"
        v-if="isVKNOWS"
      >
        <div class="information">
          <p class="display-1 title">Advance E-Training Platform</p>
          <p class="title detail white--text">
            Enhancing teaching and learning experience with breakthrough
            features.
          </p>
        </div>
      </v-card>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import Vue from "vue";
import colors from "vuetify/lib/util/colors";
import warnningComponent from "@/components/warningAlert.vue";
import { setMetaTag } from "../helper/metaTag";
export default {
  components: {
    warnningComponent,
  },
  data: () => ({
    window: 0,
    valid: true,
    valid2: true,
    valid3: true,
    snackbar: false,
    errText: "",
    model: { username: "", password: "" },
    loading: false,
    companyData: null,
    textWarning: "",
    typeWarning: "warning",
    showWarnnig: false,
    subDomain: null,
    domain: null,
    logo: null,
    logoCompany: null,
    titleCompany: null,
    selectedCompany: null,
  }),
  computed: {
    requireRule() {
      return [(v) => !!v || "Email is required"];
    },
    passwordRule() {
      return [(v) => !!v || "Password is required"];
    },
    isVKNOWS() {
      console.log(this.domain === "vknows", this.domain);
      return this.domain === "vknows";
    },
    isNerdOf() {
      console.log(this.domain === "nerdof", this.domain);
      return this.domain === "nerdof";
    },
  },
  // watch: {
  //   window(val) {
  //     if (val == 0) {
  //       this.$vuetify.theme.themes.light.primary = colors.blue.darken2;
  //     }
  //   }
  // },
  mounted() {
    // console.log(`${this.$platformDetect.os}`)
    // const user = this.$cookies.get("user_token");
    // if (user != null) {
    //   this.$router.replace({ path: "/" });
    // }

    const host = window.location.host;
    const parts = host.split(".");
    let subDomain = "";
    if (host.indexOf("localhost") > -1 && parts.length > 1) {
      if (parts[0] !== "localhost") {
        subDomain = parts[0];
      }
    } else if (parts.length >= 3) {
      subDomain = parts[0];
    }

    if (subDomain.length > 0) {
      this.subDomain = subDomain;
      if (this.subDomain === "culionline") {
        console.log("culionlineculionlineculionlineculionline");
      }
    }

    setMetaTag();
    if (host.indexOf("vknows") > -1) {
      this.domain = "vknows";
    } else {
      this.domain = "nerdof";
    }
  },
  methods: {
    warnnig(text, type) {
      this.textWarning = text;
      this.typeWarning = type;
      this.showWarnnig = true;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.getCompanyList();
      } else {
        // this.erroHandler("กรุณากรอกข้อมูลอีเมล หรือ ชื่อผู้ใช้");
      }
    },
    submitPwd() {
      if (this.$refs.form2.validate()) {
        // check password
        this.signin();
      } else {
        // this.erroHandler("กรุณาป้อนรหัสผ่าน");
      }
    },
    repassword() {
      this.loading = true;
      let idSelectCompany = this.selectedCompany.companies[0]._id;
      const url = `${this.$store.state.api}/account/manage/forgetpassword`;
      this.$http
        .put(url, { username: this.model.username, company: idSelectCompany })
        .then((resp) => {
          if (resp.status == 200) {
            this.$nextTick(() => {
              this.window = 4;
              this.$refs.form.resetValidation();
              this.$refs.form2.resetValidation();
              this.$refs.form3.resetValidation();
            });
          }
        });
    },
    backToSignIn() {
      this.model = { username: "", password: "" };
      this.selectedCompany = {};
      this.$nextTick(() => {
        this.window = 0;
        this.$refs.form.resetValidation();
        this.$refs.form2.resetValidation();
        this.$refs.form3.resetValidation();
      });
    },
    erroHandler(msg) {
      this.errText = msg;
      this.snackbar = true;
    },
    getCompanyList() {
      this.loading = true;
      const url = `${this.$store.state.api}/account/tula/login/company`;
      this.$http
        .post(url, { username: this.model.username })
        .then((resp) => {
          if (resp.status == 200) {
            if (resp.data.status == true && resp.data.result.length > 0) {
              this.companyData = resp.data.result || null;
              if (this.companyData.length > 1) {
                this.$nextTick(() => {
                  this.window = 1;
                  this.$refs.form.resetValidation();
                  this.$refs.form2.resetValidation();
                });
              } else {
                this.identifyCompany(0);
              }
            } else {
              this.warnnig("ไม่พบผู้ใช้", "warning");
              // this.erroHandler(resp.data.message);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    switchToForgetPassword() {
      this.$nextTick(() => {
        this.window = 3;
        this.$refs.form.resetValidation();
        this.$refs.form2.resetValidation();
        this.$refs.form3.resetValidation();
      });
    },
    identifyCompany(indexItem) {
      this.showWarnnig = false;
      this.selectedCompany = this.companyData[indexItem];
      Vue.prototype.$buttonColor =
        this.selectedCompany.companies[0].buttonColor;
      console.log(this.selectedCompany);
      this.logoCompany = this.selectedCompany.companies[0].logo;
      this.titleCompany = this.selectedCompany.companies[0].title;
      this.$nextTick(() => {
        this.window = 2;
        this.$refs.form.resetValidation();
        this.$refs.form2.resetValidation();
      });
    },
    // identifyCompany() {
    //   this.loading = true;
    //   const url = `${this.$store.state.api}/account/tula/login/company`;
    //   this.$http
    //     .post(url, { username: this.model.username })
    //     .then(resp => {
    //       console.log(resp);
    //       if (resp.status == 200) {
    //         if (resp.data.status == true && resp.data.result.length > 0) {
    //           this.companyData = resp.data.result[0] || null;
    //           // this.$vuetify.theme.themes.light.primary = this.companyData.companies[0].themeColor;
    //           // localStorage.setItem(
    //           //   "theme",
    //           //   this.companyData.companies[0].themeColor
    //           // );
    //           Vue.prototype.$buttonColor = this.companyData.companies[0].buttonColor

    //           this.$nextTick(() => {
    //             this.window = 1;
    //             this.$refs.form.resetValidation();
    //             this.$refs.form2.resetValidation();
    //           });
    //         } else {
    //           this.warnnig("ไม่พบผู้ใช้", "warning");
    //           // this.erroHandler(resp.data.message);
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    signin() {
      this.loading = true;
      let url = `${this.$store.state.api}/account/tula/login`;
      const params = {
        id: this.selectedCompany._id,
        password: this.model.password,
        platform: "Web app",
        device: this.$platformDetect.ua,
        osversion: `${this.$platformDetect.os}`,
        browser: `${this.$browserDetect.meta.name} ${this.$browserDetect.meta.version}`,
      };
      this.$http
        .post(url, params)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.$cookies.set(
              "user_token",
              resp.data.result.token,
              resp.data.result.endTime
            );
            this.userInfo(resp.data.result.endTime);
          } else {
            this.loading = false;
            // error handler
            // this.erroHandler("รหัสผ่านไม่ถูกต้องกรุณาลองใหม่อีกครั้ง");
            this.warnnig("รหัสผ่านไม่ถูกต้อง", "warning");
          }
        })
        .catch((err) => {
          // error handler
          this.loading = false;
          console.log(err);
          // this.erroHandler(
          //   "Something went wrong, service error or internet connection has proplem"
          // );
          this.warnnig(
            "Something went wrong, service error or internet connection has proplem",
            "warning"
          );
        });
    },
    async userInfo(exp) {
      await this.$http
        .get(`${this.$store.state.api}/account/tula/info`)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            console.log(resp.data.result.info.companies);
            let company = {
              ...resp.data.result.info.companies,
              permission: null,
            };
            const info = {
              companies: company,
              displayName: resp.data.result.info.displayName,
              email: resp.data.result.info.email,
              firstName: resp.data.result.info.firstName,
              image: resp.data.result.info.image,
              isTeacher: resp.data.result.info.isTeacher,
              lastName: resp.data.result.info.lastName,
              _id: resp.data.result.info._id,
              setting: resp.data.result.setting,
            };

            Vue.prototype.$userInfo = info;
            // this.$router.replace({
            //   name: "home"
            // });
            if (info.companies[0].connectToolsWith) {
              setGoogleAnalytic(
                info.companies[0].connectToolsWith.googleAnalytics
              );
            }
            let fromUrl = localStorage.getItem("fromUrl")
              ? JSON.parse(localStorage.getItem("fromUrl"))
              : null;
            localStorage.removeItem("fromUrl");
            fromUrl
              ? this.$router.replace({
                  path: fromUrl.path,
                  query: fromUrl.query,
                })
              : this.$router.replace({
                  name: "home",
                });
          }
        })
        .catch((err) => {});
      // .finally(() => {
      //   this.loading = false;
      // });
      let horizontal = [
        "banner_slider",
        "my_course_vertical_gridview",
        "course_vertical_gridview",
        "category_horizontal_listview",
      ];
      let vertical = [
        "teacher_horizontal_listview",
        "category_horizontal_listview",
        "tag_list",
        "grade_horizontal_listview",
      ];
      const user = Vue.$cookies.get("user_token");
      console.log(Vue.prototype.$userInfo);
      let company = Vue.prototype.$userInfo.companies[0]._id;
      let settings = Vue.prototype.$userInfo.setting;
      let item = settings.filter((item) => item.name == "Home");
      Vue.prototype.$elements = [];
      this.$http
        .get(
          `${this.$store.state.api}/home/V2?index=${item[0].priority}${
            user ? "" : "&companyID=" + company
          }`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            Vue.prototype.$elements = resp.data.result.elements;

            EventBus.$emit("updateNavBar", resp.data.result.navBarTitle);

            Vue.prototype.$itemHorizontal = resp.data.result.elements.filter(
              (item) => horizontal.includes(item.template)
            );
            dataVertical = resp.data.result.elements.filter((item) =>
              vertical.includes(item.template)
            );
            dataVertical.forEach((element) => {
              Vue.prototype.$itemVertical[element.template] = element;
            });
            this.$emit("data", Vue.prototype.$itemVertical);
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    mapCompanyBySubDomain(companies) {
      if (!this.subDomain) {
        return 0;
      }
      const companyNames = companies.map((t) => {
        return t.companies.map((c) => c.keyIcon);
      });
      let result = -1;
      for (let i = 0; i < companyNames.length; i += 1) {
        const indexOfCompany = companyNames[i].indexOf(this.subDomain);
        if (indexOfCompany > -1) {
          result = i;
          this.logo = companies[i].companies[indexOfCompany].logo;
          break;
        }
      }
      return result > -1 ? result : 0;
    },
    hasLogo() {
      return this.subDomain === "culionline";
    },
  },
};
function setGoogleAnalytic(id) {
  if (id) {
    window.ga =
      window.ga ||
      function () {
        (ga.q = ga.q || []).push(arguments);
      };
    ga.l = +new Date();
    // Trace debugging
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/debugging
    // window.ga_debug = {trace: true}
    ga("create", id, "auto");
    // if (isLocalhost) {
    //   ga('set', 'sendHitTask', null)
    // }
  }
}
</script>

<style scoped lang="scss">
// .theme--light.v-btn.v-btn--disabled.v-btnbg {
//     background-color: rgba(0, 0, 0, 0.12) !important;
// }
.scroll {
  overflow-y: auto;
}
.border-card-select {
  box-shadow: unset !important;
}
.txt-hyperLink {
  text-decoration: underline;
}
.logo {
  width: 45%;
  // width: 160px;
  margin: 0 auto;
}
.logoSelectCompany {
  width: 20%;
  // width: 160px;
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-page-nerdof {
  background: rgb(1, 143, 179);
  background: linear-gradient(
    90deg,
    rgba(1, 143, 179, 1) 0%,
    rgba(6, 48, 115, 1) 88%
  );
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-page-vknows {
  background: rgb(1, 143, 179);
  background: linear-gradient(
    90deg,
    rgba(74, 206, 159, 1) 0%,
    rgba(6, 52, 35, 0.9) 88%
  );
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
  position: relative;
}

.md-w-100 {
  width: 90%;
}
.or-line {
  width: 74%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 10px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 30px;
  color: #e0e0e0;
}
.w-auto {
  width: auto !important;
}
.m-auto {
  margin: 0 auto !important;
}
.md-position-bottom-0 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.md-position-relative {
  position: relative !important;
}

@media only screen and (max-width: 768px) {
  .or-line {
    width: 94%;
  }
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .login-page-nerdof {
    height: 100%;
    align-items: unset;
  }
  .login-page-vknows {
    height: 100%;
    align-items: unset;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .item-card {
    // width: 45%;
    width: 100%; //ipad
    min-height: 560px;
  }
  .hidden-xs {
    display: none;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    height: 100%;
    align-items: center;
  }
  .login-page-nerdof {
    height: 100%;
    align-items: center;
  }
  .login-page-vknows {
    height: 100%;
    align-items: center;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 90% !important;
  }
  .md-hidden {
    display: none;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 35%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 30%;
  }
}
.login-container {
  width: 80%;
  display: flex;
  flex-flow: row wrap;
  @media only screen and (max-width: 767px) {
    display: block;
    align-self: center;
  }
}
@media only screen and (max-width: 767px) {
  .hidden-xs {
    display: none;
  }
  .xs-no-margin {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .xs-no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .event-cover-box {
    margin-top: -14px;
  }
  .responsive_btn {
    width: 77%;
  }
}
.login-information {
  // height: 686.609px;
  // background-color: rgb(39,117,161);
  // background-color: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%);
  // background-image:url('../assets/login-information.jpg');

  // background: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%), url('../assets/login-information.jpg');
  // color: rgb(255, 255, 255);
  // min-height:100%;
  // background:linear-gradient(0deg, rgba(255, 0, 150, 0.3), rgba(255, 0, 150, 0.3)), url(http://lorempixel.com/800/600/nature/2);
  background: linear-gradient(
      90deg,
      rgba(19, 61, 160, 0.7) 0%,
      rgba(0, 174, 200, 0.7) 88%
    ),
    url("../assets/login-information.jpg");
  background-size: cover;
  // @media only screen and (max-width: 769px) {
  //   .login-information {
  //     width: 45% !important;
  //   }
  // }
  width: 65%;
  position: relative;
  .information {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translate(0, -50%);
  }
}
.login-information-nerdof {
  // height: 686.609px;
  // background-color: rgb(39,117,161);
  // background-color: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%);
  // background-image:url('../assets/login-information.jpg');

  // background: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%), url('../assets/login-information.jpg');
  // color: rgb(255, 255, 255);
  // min-height:100%;
  // background:linear-gradient(0deg, rgba(255, 0, 150, 0.3), rgba(255, 0, 150, 0.3)), url(http://lorempixel.com/800/600/nature/2);
  background: linear-gradient(
      90deg,
      rgba(19, 61, 160, 0.7) 0%,
      rgba(0, 174, 200, 0.7) 88%
    ),
    url("../assets/login-information.jpg");
  background-size: cover;
  // @media only screen and (max-width: 769px) {
  //   .login-information {
  //     width: 45% !important;
  //   }
  // }
  width: 65%;
  position: relative;
  .information {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translate(0, -50%);
  }
}
.login-information-vknows {
  // height: 686.609px;
  // background-color: rgb(39,117,161);
  // background-color: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%);
  // background-image:url('../assets/login-information.jpg');

  // background: linear-gradient(90deg, rgba(39,117,161,1) 0%, rgba(0,174,200,1) 88%), url('../assets/login-information.jpg');
  // color: rgb(255, 255, 255);
  // min-height:100%;
  // background:linear-gradient(0deg, rgba(255, 0, 150, 0.3), rgba(255, 0, 150, 0.3)), url(http://lorempixel.com/800/600/nature/2);
  background: linear-gradient(
      90deg,
      rgba(6, 52, 35, 0.8) 0%,
      rgba(76, 136, 113, 0.8) 88%
    ),
    url("../assets/login-information-vknows.webp");
  background-size: cover;
  // @media only screen and (max-width: 769px) {
  //   .login-information {
  //     width: 45% !important;
  //   }
  // }
  width: 65%;
  position: relative;
  .information {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translate(0, -50%);
  }
}
@media only screen and (min-width: 774px) and (max-width: 1028) {
  .login-information {
    width: 55%;
  }
}
.login-container {
  .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 0px;
  }
}
.display-1.title {
  line-height: 3.5rem;
  font-size: 45px !important;
  color: white;
  margin-bottom: 30px;
}
.title.detail {
  font-weight: 400;
  color: #dae5eb !important;
}
// .mt-3 {
//   margin-bottom: 30px;
// }
.origanization-detail {
  font-size: 16px;
}
.tula-title {
  font-weight: bold !important;
  font-size: 26px !important;
}
.next-btn {
  font-size: 18px;
  border-radius: 0%;
}
.account-color {
  color: #072f72;
  font-weight: bold;
}
.txt-field {
  border-radius: 0%;
}
</style>
<style lang="scss">
/* .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: unset;
} */
.btn-section {
  .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgba(0, 0, 0, 0.12) !important;
  }
}
.user-icon {
  .v-icon.v-icon {
    font-size: 22px !important;
    color: #b5b5b5;
  }
}
</style>
